import React from 'react';
import { t } from '@lingui/macro';
import { AdminInhouseCodeManagementDataTable, AdminPageTitle } from '../components';

export const AdminInhouseCodeManagementPage: React.FC = () => {
  return (
    <>
      <AdminPageTitle title={t`Koçan Yönetimi`} />
      <AdminInhouseCodeManagementDataTable />
    </>
  );
};
